// What to tell someone whose credential share or access approval the server refused because the
// company credential is being re-checked (409) or is no longer verified (410). The server sent
// nothing in either case. Both are shown as a notice, not as an error; every other failure keeps the
// message its dialog already shows.

import { credentialTrustStateOf, credentialTrustMessageId } from '../../util/credentialTrust';

// The message for a refusal that is one of the two answers, or null for any other failure.
export const credentialTrustNotice = (error, intl) => {
  const messageId = credentialTrustMessageId(credentialTrustStateOf(error));
  return messageId ? intl.formatMessage({ id: messageId }) : null;
};

// `notify` is { warning, error }, each taking the text to show; `describe` gives the dialog's own
// message for any other failure.
export const reportCredentialFailure = (error, { intl, notify, describe }) => {
  const notice = credentialTrustNotice(error, intl);
  if (notice) {
    notify.warning(notice);
  } else {
    notify.error(describe(error));
  }
};
